<app-kazaplan-diaporama-popin
  *ngIf="!(kfs.getDisplayCurrentKazaplan() | async)"
></app-kazaplan-diaporama-popin>
<app-kazaplan-viewer
  style="height: 100%; display: flex;"
  *ngIf="(kfs.getDisplayCurrentKazaplan() | async) != null && (kfs.getCurrentKazaplan() | async) !== null"
  [style.display]="((kfs.getDisplayCurrentKazaplan() | async) == false) ? 'none': 'flex'"
  [planId]="(kfs.getCurrentKazaplan() | async).id"
  [htmlId]="htmlId"></app-kazaplan-viewer>
